export function useVote(dealId: string) {
  const api = useApi()
  const { user } = useAuth()
  const { trackEvent } = useUmami()

  const userVote = ref<'UP' | 'DOWN' | null>(null)
  const voteCount = ref(0)
  const loading = ref(false)

  async function vote(type: 'UP' | 'DOWN') {
    if (!user.value) {
      trackEvent('vote-login-required', { dealId, type })
      await navigateTo(`/login?redirect=${encodeURIComponent(useRoute().fullPath)}`)
      return
    }

    loading.value = true
    try {
      // Toggle: se já votou o mesmo, remove o voto
      const newType = userVote.value === type ? null : type

      await api(`/deals/${dealId}/vote`, {
        method: 'POST',
        body: { type: newType },
      })

      if (newType === null) {
        voteCount.value += userVote.value === 'UP' ? -1 : 1
      }
      else if (userVote.value === null) {
        voteCount.value += type === 'UP' ? 1 : -1
      }
      else {
        voteCount.value += type === 'UP' ? 2 : -2
      }

      userVote.value = newType
      trackEvent('deal-vote', { dealId, type: newType ?? 'removed' })
    }
    finally {
      loading.value = false
    }
  }

  return { userVote, voteCount, loading, vote }
}
